<template>
    <div :style="{ backgroundImage: `url(${backgroundUrl})`, backgroundSize: 'cover' }">
    
        <CCol sm="12" lg="12" class="mx-auto" style="width: 100%; background-size: cover; color: #fff;">
    
            <CCol sm="12" lg="12" style="width: 80%;background-size: cover; margin: auto;color: #fff" class="p-3">
                <CRow class="mt-2 mt-2 ml-3 mr-3">
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <CCard class="b-20 text-black">
                                <div class="text-left">
                                    <CButton type="button" class="btn color-blue float-left" @click="GoToCourse()">
                                        <img style="width:20px" src="../assets/img/arrow-left.png" /> </CButton>
                                </div>
    
                                <h3 class="text-black text-center poppin-text mt-4 ml-3 custom-header-form">Upload Tournament</h3>
                                <p class="m-3 custom20px-400">
                                    Thank you for your interest in adding a new tournament to our list! <br /> Please fill out the following details to provide information about the tournament</p>
                                <CCol sm="12" lg="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                                    <CRow>
                                        <CCol sm="12">
                                            <label class="text-black custom-title-form">Title</label>
                                            <input type="text" v-model="Title" class="custom-input-app" placeholder="eg. Tournament Hoki" />
    
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Organizer</label>
                                            <input type="text" v-model="Organizer" class="custom-input-app" placeholder="eg. KPPKB" />
    
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Category</label>
                                            <input type="text" v-model="Category" placeholder="eg. Hoki" class="custom-input-app" />
                                        </CCol>
    
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Price</label>
                                            <input type="text" v-model="Amount" placeholder="eg. 120.00" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Additional fees per member(RM)</label>
                                            <input type="text" v-model="ChargePerMember" placeholder="eg. 1" class="custom-input-app" />
                                        </CCol>
                                       
                                       
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Shedule Date Start</label>
                                            <input type="datetime-local" v-model="ScheduleDateTime" placeholder="eg. 120.00" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="6" class="mt-3">
                                            <label class="text-black custom-title-form">Schedule Date End</label>
                                            <input type="datetime-local" v-model="ScheduleDateTimeEnd" placeholder="eg. Hoki" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="12" class="mt-3">
                                            <label class="text-black custom-title-form">Location</label>
                                            <input type="text" v-model="Location" placeholder="eg. Kuala Lumpur" class="custom-input-app" />
                                        </CCol>
                                        <CCol sm="12" class="mt-3">
                                            <label class="text-black custom-title-form">Content</label>
                                            <tinymce id="d1" v-model="Content" placeholder="Enter Your Information Tournament"></tinymce>
                                        </CCol>
                                      
    
                                   
    
                                        <CCol sm="12" class="mt-4">
                                            <label class="text-black custom-title-form">Upload Thumbnail</label>
                                            <br />
                                            <input type="file" id="thumbnail" ref="mythumbnail" @change="onFileChangeThumbnail" />
    
                                            <div id="preview">
                                                <img style="max-width: 200px" v-if="urlThumbnail" :src="urlThumbnail" />
                                            </div>
                                        </CCol>

                                        <CCol sm="12" class="mt-4">
                                            <label class="text-black custom-title-form">Upload Banner</label>
                                            <br />
                                            <input type="file" id="banner" ref="mybanner" @change="onFileChangeBanner" />
    
                                            <div id="preview">
                                                <img style="max-width: 200px" v-if="urlBanner" :src="urlBanner" />
                                            </div>
                                        </CCol>
                                        <CCol sm="12" class="mt-4">
                                            <label class="text-black custom-title-form">Upload Terms & Conditions</label>
                                            <br />
                                            <input type="file" id="terms" ref="myterms" @change="onFileChangeTerms" />
    
                                            <div id="preview">
                                                <object v-if="urlTerms" :data="urlTerms" type="application/pdf" width="100%" height="500px">
    <p>Your browser does not support PDFs. Please download the PDF to view it: <a :href="urlTerms">Download PDF</a>.</p>
</object> />
                                            </div>
                                        </CCol>

                                        <CCol sm="12">
                                            <div v-if="SuccessMessage == true" class="mt-3">
                                                <CAlert show color="success">Successfully to Save Detail</CAlert>
                                            </div>
                                        </CCol>
    
                                        <div v-if="SubmittedForm === true">
                                            <label>Loading....</label>
                                        </div>
    
                                        <CButton type="button" class="bg-button-blue text-white m-2" block :disabled="isDisabled" @click="InsertVideoData">Submit</CButton>
    
    
                                    </CRow>
                                    <br /><br />
                                </CCol>
                            </CCard>
                            <br /><br />
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
            <br /><br /><br />
        </CCol>
    
    
    </div>
</template>


<script>
import Vue from "vue";
import AOS from "aos";
import "aos/dist/aos.css";

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import Mainlayout from "../containers/AllHeader.vue";
import backgroundUrl from "../assets/img/bgl1.png";

import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);

export default {
    name: "App",
    components: {
        Mainlayout
    },
    created() {
        AOS.init();
    },
    data: () => ({
        user: {},


        thumbnail: [],
        uploadedFiles: [],
        terms: [],



        Title: "",
        Category: "",

      
        Amount: "",
        Location: "",
        ScheduleDateTime: "",
      ScheduleDateTimeEnd: "",
      ChargePerMember: "",
      Organizer: "",
      Content: "",




        Filename: "",
        urlThumbnail: null,
        urlBanner: null,
        urlTerms: null,
       

        SuccessMessage: false,
        SubmittedForm: false,
        backgroundUrl,


    }),
    async mounted() {
    
    },
    //async mounted() {},
    methods: {
        getFileName(url) {
            if (url) {
                const parts = url.split('/');
                return parts[parts.length - 1]; // Get the last part which is the filename
            }
            return ''; // Return empty string if url is not provided
        },
       
       
        GoToCourse() {
            this.$router.push("/");
        },
        
        
      
        onFileChangeThumbnail(e) {
            const file = e.target.files[0];
            this.urlThumbnail = URL.createObjectURL(file);
            this.HandleFileInputThumbnail();
        },
        HandleFileInputThumbnail() {
            console.log(this.$refs.mythumbnail.files);
            this.thumbnail = this.$refs.mythumbnail.files;
            //this.SubmitFileApplicationDescription1();
        },

        onFileChangeBanner(e) {
            const file = e.target.files[0];
            this.urlBanner = URL.createObjectURL(file);
            this.HandleFileInputBanner();
        },
        HandleFileInputBanner() {
            console.log(this.$refs.mybanner.files);
            this.banner = this.$refs.mybanner.files;
            //this.SubmitFileApplicationDescription1();
        },
        onFileChangeTerms(e) {
            const file = e.target.files[0];
            this.urlTerms = URL.createObjectURL(file);
            this.HandleFileInputTerms();
        },
        HandleFileInputTerms() {
            console.log(this.$refs.myterms.files);
            this.terms = this.$refs.myterms.files;
            //this.SubmitFileApplicationDescription1();
        },
      
      
   
        InsertVideoData() {
            console.log("test" + this.SelectedLevel);
            this.SubmittedForm = true;
            const formData = new FormData();
            formData.append("Title", this.Title);
            formData.append("Amount", this.Amount);
            formData.append("Category", this.Category);
            formData.append("Location", this.Location);
            formData.append("Content", this.Content);
            formData.append("thumbnail", this.thumbnail[0]);
            formData.append("banner", this.banner[0]);
            formData.append("ScheduleDateTime", this.ScheduleDateTime);
            formData.append("ScheduleDateTimeEnd", this.ScheduleDateTimeEnd);
            formData.append("ChargePerMember", this.ChargePerMember);
            formData.append("Organizer", this.Organizer);
            formData.append("terms", this.terms[0]);



            return this.$API
                .post(this.$UploadTournament, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;

                    if (response.status == 200) {
                        this.SuccessMessage = true;
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
       

   
     